import '../../../../../../services/MarppleShop/shared/style/global.scss';
import 'intersection-observer';
import '../../custom-event.js';
import '../../lib/impetus.js';
import '../../sticky.js';
import '../../component.js';
import '../../component_like.js';
import '../../lazyload.js';
import '../../resize_sensor.js';
/**
 * @desc
 * scripts1.js 파일에서 번역 파일을 로드합니다.
 * 로드 후 window 객체에 T, TT, ET 와 같은 함수를 추가합니다.
 * scripts1.js 파일을 기준으로 위 파일들은 번역 로드와 상관없이 실행될 수 있습니다.
 * 번역이 필요없는 entry 파일은 위에 위치해주시기 바랍니다.
 * scripts1.js 파일을 기준으로 아래 파일들은 번역 로드 후 실행되어야 합니다.
 * 번역이 꼭 필요한 파일의 경우 아래에 위치해주시기 바랍니다.
 */
import './scripts1.js';

await Promise.all([import('./init.js'), import('./pure_index.js')]);
